






































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import TitleSection from "../titleSection/titleSection.vue";
import FeedItem from "./feedItem/FeedItem.vue";
import FeedCoins from "./feedOffers/FeedCoins.vue";
import FeedOffer from "./feedOffers/FeedOffers.vue";
import loginStatus from "./statusSection/loginStatus.vue";
import emptyFeedStatus from "./statusSection//emptyFeedStatus.vue";
import limiteStatus from "./statusSection/limitedStatus.vue";
import FeedVip from "./feedVip/FeedVip.vue";
import * as types from "@/store/constants/types";
import * as statusConst from "@/store/constants/status";
import EarnCoinLimitedCoin from "../earnLimitedCoins/EarnLimitedCoins.vue";
import FeedSuperPay from "./feedSuperPay/FeedSuperPay.vue";
import FeedBackUpApp from "./feedBackUpApp/FeedBackUpApp.vue";
@Component({
  components: {
    TitleSection,
    FeedItem,
    FeedCoins,
    loginStatus,
    emptyFeedStatus,
    limiteStatus,
    FeedVip,
    FeedOffer,
    EarnCoinLimitedCoin,
    FeedSuperPay,
    FeedBackUpApp
  }
})
export default class Pool extends Vue {
  @Prop({ default: 0 })
  private limitedCountNum?: number;
  @Prop({ default: 0 })
  private vipCountDownTime?: number;
  @Prop({ default: "" })
  private status!: string;
  @Getter(types.GETTER_CURRENT_FEED)
  private currentFeed: any;
  @Prop({ default: 0 })
  private skipDelayCountNum!: number;
  @Prop({ default: 1 })
  private randomFeedCoinsStatus!: number;

  private limitedCoinShow: boolean = false; //控制初始化
  private limitedCoinRealShow: boolean = false; //内部实际是否显示

  @Watch("status", { immediate: true })
  private statusChange(val: any, oldVal: any) {
    //监听stuats,如果status为VIP或者Feed_coins
    console.log("statusChange:>>>", {
      val,
      oldVal
    });

    if (this.status === statusConst.FEED_COIN ||
        this.status === statusConst.FEED_VIP ||
        this.status === statusConst.FEED_CASINO_SPIN ||
        this.status === statusConst.FEED_CASINO_SLOTS ||
        this.status === statusConst.FEED_CASINO_SIC ||
        this.status === statusConst.FEED_LUCKY_COIN ||
        this.status === statusConst.FEED_AD ||
        this.status === statusConst.FEED_SUPER_PAY ||
        this.status === statusConst.FEED_BACK_UP ||
        this.casinoSicShow ||
        this.casinoSpinShow ||
        this.casinoSlotShow ||
        this.feedLuckyCoinsShow ||
        this.feedAdsShow
    ) {
      this.limitedCoinShow = false;
    } else if (
      //如果limited在时间返回为的话，并且没有显示limitedCoin，则需要再显示：
      !this.limitedCoinShow &&
      (val === statusConst.FEED_NORMAL || val === statusConst.TIME_LIMIT)
    ) {
      this.limitedCoinShow = true;
    }
  }

  get currentFeedData() {
    return this.currentFeed
      ? this.currentFeed
      : {
          offer: {},
          kind: "",
          sub_kind: ""
        };
  }

  get userTitleShow() {
    console.log('limitedCoinRealShow',this.limitedCoinRealShow)
    return this.status === statusConst.FEED_NORMAL && !this.limitedCoinRealShow
      ? true
      : false;
  }

  get feedResource() {
    return this.currentFeed && this.currentFeed.subresources
      ? this.currentFeed.subresources
      : [];
  }

  get feedCoinShow() {
    return this.status === statusConst.FEED_COIN ? true : false;
  }

  get feedVipShow() {
    return this.status === statusConst.FEED_VIP ? true : false;
  }

  get feedNormalShow() {
    return this.status === statusConst.FEED_NORMAL ? true : false;
  }

  get needLoginShow() {
    return this.status === statusConst.NEED_LOGIN ? true : false;
  }

  get feedEmptyShow() {
    return this.status === statusConst.FEED_EMPTY ? true : false;
  }

  get limitedShow() {
    return this.status === statusConst.TIME_LIMIT ? true : false;
  }

  get casinoSpinShow() {
    //转盘
    return this.status === statusConst.FEED_CASINO_SPIN ? true : false;
  }

  get casinoSlotShow() {
    //老虎机是否显示
    return this.status === statusConst.FEED_CASINO_SLOTS ? true : false;
  }

  get casinoSicShow() {
    //筛子
    return this.status === statusConst.FEED_CASINO_SIC ? true : false;
  }

  get feedSuperPayShow() {
    return this.status === statusConst.FEED_SUPER_PAY;
  }

  get backUpPayShow() {
    return this.status === statusConst.FEED_BACK_UP;
  }

  get feedAdsShow() {
    //显示广告
    return this.status === statusConst.FEED_AD ? true : false;
  }

  get feedLuckyCoinsShow() {
    //lucky
    return this.status === statusConst.FEED_LUCKY_COIN ? true : false;
  }

  private clickPool() {
    this.$emit("clickPool");
  }
}
